import {Card, Col, Container, Form, Nav, Row, Spinner} from 'react-bootstrap'
import React, { useState } from 'react'
import HeaderBar from '@editor/components/headerBar'
import ArticleForm from '@editor/components/articleForm/articleForm'
import SsmlForm from '@editor/components/ssmlForm'
import ToolBar from '@editor/components/toolBar/toolBar'
import './index.scss'
import EditorForm from '@editor/components/editorForm'
import SelectionBar from '@editor/components/selectionBar'
import TagBar from '@editor/components/tagBar/tagBar'
import { EditorProvider } from '@editor/components/editorContext'
import JobDetail from '@editor/components/jobDetail'
import { useParams } from 'react-router-dom'
import './ssmlTagStyles.scss'
import { HistoryProvider } from '@editor/components/misc/historyController'
import { useSelector } from 'react-redux'
import { getJobLoading } from '@editor/store/selectors/job.selector'

const Editor = () => {
  const { jobId } = useParams()
  const [activeTab, setActiveTab] = useState<string>(
    jobId !== null ? 'Editor' : 'Article'
  )

  const switchForm = (selectedKey: string | null) => {
    if (selectedKey) setActiveTab(selectedKey)
  }

  const isJobLoading = useSelector(getJobLoading)

  return (
    <EditorProvider>
      <Container id="editor_root" fluid className="h-100">
        <Row className="h-100">
          <HeaderBar></HeaderBar>
        </Row>
        { !!isJobLoading && (
          <div className={'d-flex justify-content-center align-items-center text-white mt-4'}>
            <Spinner className={'me-3'}/>Článek se načítá a normalizuje
          </div>
        )}
        { !isJobLoading && (
        <Row
          className="mt-4 app-max-width"
          style={{ display: !!jobId ? 'flex' : 'none' }}
        >
          <Col xs={7} className="flex-grow-1">
            <Card className="bg-light-subtle px-2">
              <Card.Header className="bg-light-subtle">
                <JobDetail></JobDetail>
                <Nav variant="tabs" activeKey={activeTab} onSelect={switchForm}>
                  <Nav.Item>
                    <Nav.Link eventKey="Article">Článek</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="Editor">Editor</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="SSML">SSML</Nav.Link>
                  </Nav.Item>
                </Nav>
              </Card.Header>
              <Card.Body>
                <div className="mb-3">
                  <div
                    className="tab-content"
                    style={{
                      display: activeTab === 'Article' ? 'block' : 'none',
                    }}
                  >
                    <ArticleForm />
                  </div>
                  <div
                    className="tab-content"
                    style={{
                      display: activeTab === 'Editor' ? 'block' : 'none',
                    }}
                  >
                    <HistoryProvider>
                      <EditorForm />
                    </HistoryProvider>
                  </div>
                  <div
                    className="tab-content"
                    style={{ display: activeTab === 'SSML' ? 'block' : 'none' }}
                  >
                    <HistoryProvider>
                      <SsmlForm />
                    </HistoryProvider>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={5} style={{ maxWidth: '500px' }}>
            <Row>
              <ToolBar activeTab={activeTab}></ToolBar>
            </Row>
            <Row
              style={{
                display: activeTab === 'Editor' ? 'block' : 'none',
              }}
            >
              <SelectionBar />
              <Row
                style={{
                  display: activeTab === 'Editor' ? 'block' : 'none',
                }}
              >
                <TagBar />
              </Row>
            </Row>
          </Col>
        </Row>)}
      </Container>
    </EditorProvider>
  )
}

export default Editor
